module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/RSS-86829323b08b2ce0e6319090c1ac300d.svg";